/**
 * Kereső componens
 *
 * @author Erik Bánhalmi 2017.01.26.
 */
import searchTemplate from './search.pug';
import searchServiceModule from './search-service';
import duScroll from 'angular-scroll';
import searchAutosuggestBoxServiceModule from '../search-autosuggest-box/search-autosuggest-box-service';
import queryString from 'query-string';

const MODULE_NAME = 'search';
class SearchController {
	constructor(searchService, searchAutosuggestBoxService, $http, $window, $document, $scope, $timeout) {
		'ngInject';
		this._$http = $http;
		this._$window = $window;
		this._$document = $document;
		this._searchService = searchService;
		this.searchAutosuggestBoxService = searchAutosuggestBoxService;
		this._$scope = $scope;
		this._$timeout = $timeout;
		this.currentPage = 1;
		this.itemsPerPage = 5;
		this.initialized = false;
	}
	$onInit() {
		let parsed = queryString.parse(window.location.search);
		if (parsed.searchText) {
			this.searchText = parsed.searchText;
			this.searchQuery = this.searchText;
			this._$timeout(() => {
				this.selectPage();
			}, 0);
		}
	}
	doSearch() {
		this.searchText = this.searchQuery;
		this.selectPage();
	}
	doSearchWithEnter(e) {
		if(e.which == 13) {
			this.doSearch();
		}
	}
	selectPage() {
		const TOP_ANCHOR = angular.element(document.getElementById('top-anchor'));
		this._$document.scrollToElement(TOP_ANCHOR);
		this._searchService.getSearchResults(this.searchText, this.currentPage - 1, this.searchLang).then(
			(results) => {
				if (results.status == 200) {
					this.resultsData = results.data;
					document.getElementById('top-anchor').focus();
				}
			}, (err) => {
				console.log(err);
		});
	}
	getSearchResults($viewValue) {
		return this.searchAutosuggestBoxService.getSearchResults($viewValue, this.searchLang);
	}

	autoSuggestSelected(item, model, label, event) {
		if ((event.type == 'keydown' && event.code == 'Enter') || event.type == 'click') {
			this.doSearch();
		}
	}
}

export default angular.module(MODULE_NAME, [searchServiceModule, searchAutosuggestBoxServiceModule, duScroll])
	.component(MODULE_NAME, {
		controller: SearchController,
		template: searchTemplate(),
		bindings: {
			searchLang: '@'
		}
	}).name;



// WEBPACK FOOTER //
// ../source/application/search/search.js